import { rtkApi } from '@/apis/rtkApi';

export interface EmailNotification {
  _id: string;
  userId?: string;
  emailTemplateKey: string;
  emailAddress: string;
  subject: string;
  contractId?: string;
  deepLink?: string;
  status: 'sent' | 'delivered' | 'opened' | 'clicked' | 'failed';
  sentAt: string;
  openedAt?: string;
  clickedAt?: string;
  errorMessage?: string;
  metadata?: Record<string, any>;
}

export interface GetEmailNotificationsRequest {
  limit?: number;
  offset?: number;
  userId?: string;
  contractId?: string;
  status?: string;
  emailTemplateKey?: string;
  startDate?: string;
  endDate?: string;
}

export interface GetEmailNotificationsResponse {
  count: number;
  notifications: EmailNotification[];
}

export interface EmailNotificationStats {
  totalSent: number;
  delivered: number;
  opened: number;
  clicked: number;
  failed: number;
  openRate: string;
  clickRate: string;
  deliveryRate: string;
}

export const emailNotificationApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailNotifications: builder.query<
      GetEmailNotificationsResponse,
      GetEmailNotificationsRequest
    >({
      query: (params) => ({
        url: `/admin/email-notifications`,
        params,
      }),
      providesTags: ['Email Notification'],
    }),
    getEmailNotificationStats: builder.query<
      EmailNotificationStats,
      { startDate?: string; endDate?: string }
    >({
      query: (params) => ({
        url: `/admin/email-notifications/stats`,
        params,
      }),
      providesTags: ['Email Notification'],
    }),
    getUserEmailNotifications: builder.query<
      GetEmailNotificationsResponse,
      { userId: string; limit?: number; offset?: number }
    >({
      query: ({ userId, ...params }) => ({
        url: `/admin/email-notifications/user/${userId}`,
        params,
      }),
      providesTags: ['Email Notification'],
    }),
    getContractEmailNotifications: builder.query<
      GetEmailNotificationsResponse,
      { contractId: string; limit?: number; offset?: number }
    >({
      query: ({ contractId, ...params }) => ({
        url: `/admin/email-notifications/contract/${contractId}`,
        params,
      }),
      providesTags: ['Email Notification'],
    }),
    resendEmailNotification: builder.mutation<EmailNotification, string>({
      query: (notificationId) => ({
        url: `/admin/email-notifications/${notificationId}/resend`,
        method: 'POST',
      }),
      invalidatesTags: ['Email Notification'],
    }),
  }),
});

export const {
  useGetEmailNotificationsQuery,
  useGetEmailNotificationStatsQuery,
  useGetUserEmailNotificationsQuery,
  useGetContractEmailNotificationsQuery,
  useResendEmailNotificationMutation,
} = emailNotificationApi;
